export default "__VITE_ASSET__B1VROY99__"